import ScalarWrappingText_vue_vue_type_script_setup_true_lang_default from "./ScalarWrappingText.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarWrappingText/ScalarWrappingText.vue
var ScalarWrappingText_default = ScalarWrappingText_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarWrappingText_default as default };

//# sourceMappingURL=ScalarWrappingText.vue.js.map